export const OAUTH_CALLBACK_ROUTE_PATHS = ["/auth/oauth", "/companion/auth/oauth"];

export const hasOAuthCallbackCode = (query: Record<string, unknown>) => {
  return typeof query.code === "string";
};

export const getCompanionOAuthCallbackRedirectPath = ({
  path,
  query,
  isCompanionOAuthRedirectEnabled,
}: {
  path: string;
  query: Record<string, unknown>;
  isCompanionOAuthRedirectEnabled: boolean;
}) => {
  if (!isCompanionOAuthRedirectEnabled || !hasOAuthCallbackCode(query)) {
    return undefined;
  }

  if (OAUTH_CALLBACK_ROUTE_PATHS.includes(path)) {
    return undefined;
  }

  return "/auth/oauth";
};
